import { ApplicationModes } from '../constants/application-modes';

export const getApplicationMode: ({
	isRovoEnabled,
}: {
	isRovoEnabled: boolean;
}) => 'unified' | 'rovo' = ({ isRovoEnabled }: { isRovoEnabled: boolean }) => {
	if (isRovoEnabled) {
		return ApplicationModes.Rovo;
	}
	return ApplicationModes.Unified;
};
